import { Component, h, Host, Listen, Prop, State, Watch } from '@stencil/core'
import { _debug } from '../../../../common/debugger/debugger'
interface PageInfo {
  index: number;
  active?: boolean;
  title: string;
}
@Component({
  tag: 'form-paging',
  shadow: true
})
export class Paging {
 
  @Prop() direction: 'prev' | 'next'
  @Prop() i18n
  @Prop({ mutable: true }) pages: PageInfo[]

  @State() page: number

  // get current active page from new pages
  @Watch('pages')
  onPageInfosChange(pages) {
    this.page = pages.findIndex(i => i.active)
  }

  // listen to event from form renderer and save infos
  @Listen("pagechanged", { target: 'document' }) newPageInfos(evt) {
    this.pages = evt.detail?.pageInfos
    _debug('in paging, pages:', this.pages)
  }

  // change hash according to navigation direction
  changeHash(direction: 'prev' | 'next') {
    window.location.hash = direction === 'next' ? '#'+ (this.page + 1) : '#' + (this.page - 1)
  }

  render() {
    return (
      <Host>
        {
          // show buttons only if current page is defined
          this.page !== undefined
          // don't show buttons on last page
          && (this.page + 1) < this.pages.length && (
            <nav>
              {
                // if no direction property is given or is "prev"
                (this.direction === 'prev' || !this.direction) 
                // if not on first page
                && this.page > 0                
                &&
                  <muse-button rel="prev" variant="ghost" onClick={()=> this.changeHash('prev')}>
                    {this.i18n?.previousBtn}
                    <muse-icon slot="icon-start" name="chevron-left"></muse-icon>
                  </muse-button>
              }
              {
                // if no direction property is given or is "next"
                (this.direction === 'next' || !this.direction) 
                // if there is more then one page
                && this.pages.length > 1
                &&
                  <muse-button rel="next" onClick={()=> this.changeHash('next')}>
                    {this.i18n?.nextBtn}
                    <muse-icon slot="icon-end" name="chevron-right"></muse-icon>
                  </muse-button>
              }
            </nav>
          )          
        }
      </Host>
    )
  }
}
